import React from "react";

// COMPONENTS
import ActivityIndicator from "@components/ActivityIndicator/ActivityIndicator";

// HELPERS
import * as utils from "@helpers/utils";


export default class Button extends React.PureComponent {
    click() {
        this.refs.button.click();
    }

    render() {
        const { props } = this;
        const { id, style, label, busy, size, type, filled, appearance, disabled, fullWidth, onClick, dataInteractive } = props;
        const classes = utils.createClassName(props.className, {
            "Button": true,
            "full-width": fullWidth === true,
            "busy": busy === true,
            "small": size === "small",
            "filled": filled === true,
            "primary": appearance === "primary",
            "secondary": appearance === "secondary",
            "medium": appearance === "medium",
            "dark": appearance === "dark",
            "success": appearance === "success",
            "warning": appearance === "warning",
            "danger": appearance === "danger",
            "white": appearance === "white",
            "light": appearance === "light",
        });

        return (
            <button
                id={ id }
                ref="button"
                style={ style }
                className={ classes }
                type={ type || "button" }
                disabled={ disabled }
                onClick={ onClick }
                data-interactive={dataInteractive || ""}
            >
                <div id={ id } className="Button-container"> {/* note this shares the same id as the parent for effective identification when capturing the id on onClick events */}
                    <ActivityIndicator busy={ busy } scale={0.8} />
                    <div className="Button-label">{ label || "" }</div>
                </div>
            </button>
        );
    }
}